import React, { useContext, VFC } from 'react';
import T from 'i18n-react';
import { useTheme } from '@material-ui/core/styles';

import SignupImage from '../../../../../images/nav/signup.png';
import LoginImage from '../../../../../images/nav/login.png';
import { AuthDialogContext } from '../../AuthDialog/AuthDialogContextProvider';
import Styled from '../Styled';
import ImgIconWithWord from '../molecules/ImgIconWithWord';
import SearchIconLink from '../molecules/SearchIconLink';

const { IconWrapper, IconLink } = Styled;

interface Props {
  handleOpenSearchDrawer: () => void;
}
const NotLoggedInContent: VFC<Props> = ({ handleOpenSearchDrawer }: Props) => {
  const theme = useTheme();
  const {
    handleOpen: handleOpenAuthDialogInContext,
    handleOpenSignupDialog: handleOpenSignupDialogInContext,
  } = useContext(AuthDialogContext);

  const handleOpenAuthDialog = () => {
    handleOpenAuthDialogInContext();
  };
  const handleOpenSignupDialog = () => {
    handleOpenSignupDialogInContext();
  };

  return (
    <>
      <SearchIconLink onClick={handleOpenSearchDrawer} />
      <IconWrapper theme={theme}>
        <IconLink>
          <ImgIconWithWord
            src={SignupImage}
            alt={T.translate('signup') as string}
            word={T.translate('signup')}
            onClick={handleOpenSignupDialog}
          />
        </IconLink>
      </IconWrapper>
      <IconWrapper theme={theme}>
        <IconLink>
          <ImgIconWithWord
            src={LoginImage}
            alt={T.translate('login') as string}
            word={T.translate('login')}
            onClick={handleOpenAuthDialog}
          />
        </IconLink>
      </IconWrapper>
    </>
  );
};

export default NotLoggedInContent;
